// Translation lookup with TranslationRegistry → LanguageManager → key fallback chain.
// Returns the original key when no translation system is available so UI never blanks.

export function translateKey(key) {
    if (window.TranslationRegistry && typeof window.TranslationRegistry.translate === 'function') {
        const lang = window.LanguageManager ? window.LanguageManager.getCurrentLanguage() : (window.LANG || 'EN');
        const translation = window.TranslationRegistry.translate(key, lang);
        if (translation !== key) {
            return translation;
        }
    }

    if (window.LanguageManager && typeof window.LanguageManager.translate === 'function') {
        const translation = window.LanguageManager.translate(key);
        if (translation !== key) {
            return translation;
        }
    }

    return key;
}
